import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        "flex min-h-[96px] w-full rounded-[12px] border border-brand-border bg-white px-4 py-3 text-base",
        "text-brand-text placeholder:text-brand-muted resize-y",
        "transition-[border-color,box-shadow] duration-200 ease-out",
        "focus-visible:outline-none focus-visible:border-brand-accent focus-visible:ring-2 focus-visible:ring-brand-accent/25",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-brand-surface",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
